import React, { useState } from 'react';
import { FaIndustry, FaOilCan, FaBolt, FaMicrochip, FaFlask, FaRocket, FaTrain, FaBuilding, FaChartLine, FaUsers, FaCheckCircle, FaBook, FaLaptop, FaClock, FaTrophy, FaChevronDown, FaChevronUp, FaWrench, FaAtom, FaHardHat, FaShip, FaPlane, FaMountain, FaFileAlt } from 'react-icons/fa';

const PSUPage = () => {
  const [expandedPSU, setExpandedPSU] = useState(null);
  const [expandedBranch, setExpandedBranch] = useState(null);

  const majorPSUs = [
    {
      id: 'ongc',
      name: 'ONGC (Oil and Natural Gas Corporation)',
      sector: 'Oil & Gas',
      icon: <FaOilCan />,
      description: 'India\'s largest oil and gas exploration and production company',
      eligibleBranches: ['Petroleum Engineering', 'Mechanical', 'Electrical', 'Chemical', 'Civil', 'Instrumentation', 'Geology & Geophysics', 'Electronics'],
      positions: [
        { role: 'Assistant Technician', branches: ['Mechanical', 'Electrical', 'Electronics', 'Instrumentation'], grade: 'Grade-III' },
        { role: 'Junior Assistant Technician', branches: ['Mechanical', 'Electrical', 'Chemical'], grade: 'Grade-II' },
        { role: 'Geologist', branches: ['Geology & Geophysics'], grade: 'Grade-A' },
        { role: 'Chemist', branches: ['Chemistry'], grade: 'Grade-A' },
        { role: 'Assistant Engineer', branches: ['Mechanical', 'Electrical', 'Civil', 'Instrumentation'], grade: 'Grade-A' }
      ],
      salary: '₹40,000 - ₹1,40,000/month',
      exam: 'GATE Score + Written Test + Interview'
    },
    {
      id: 'ntpc',
      name: 'NTPC (National Thermal Power Corporation)',
      sector: 'Power',
      icon: <FaBolt />,
      description: 'India\'s largest energy conglomerate with roots in power generation',
      eligibleBranches: ['Electrical', 'Mechanical', 'Electronics', 'Instrumentation', 'Civil', 'Chemical', 'Computer Science'],
      positions: [
        { role: 'Executive Trainee (Electrical)', branches: ['Electrical', 'EEE'], grade: 'E1' },
        { role: 'Executive Trainee (Mechanical)', branches: ['Mechanical'], grade: 'E1' },
        { role: 'Executive Trainee (Electronics)', branches: ['Electronics', 'ECE'], grade: 'E1' },
        { role: 'Executive Trainee (Instrumentation)', branches: ['Instrumentation', 'ICE'], grade: 'E1' },
        { role: 'Executive Trainee (Civil)', branches: ['Civil'], grade: 'E1' },
        { role: 'Diploma Trainee', branches: ['Electrical', 'Mechanical', 'Electronics', 'Instrumentation'], grade: 'D' }
      ],
      salary: '₹60,000 - ₹1,80,000/month',
      exam: 'GATE Score + Group Discussion + Interview'
    },
    {
      id: 'iocl',
      name: 'IOCL (Indian Oil Corporation Limited)',
      sector: 'Oil & Gas',
      icon: <FaOilCan />,
      description: 'India\'s largest commercial enterprise in petroleum refining and marketing',
      eligibleBranches: ['Mechanical', 'Chemical', 'Electrical', 'Instrumentation', 'Civil', 'Metallurgy', 'Petroleum'],
      positions: [
        { role: 'Junior Engineering Assistant', branches: ['Mechanical', 'Electrical', 'Instrumentation', 'Civil'], grade: 'Grade-IV' },
        { role: 'Technical Officer', branches: ['Mechanical', 'Chemical', 'Electrical'], grade: 'Grade-A' },
        { role: 'Junior Quality Control Analyst', branches: ['Chemistry', 'Chemical Engineering'], grade: 'Grade-A' },
        { role: 'Research Officer', branches: ['Chemical', 'Mechanical', 'Petroleum'], grade: 'Grade-A' }
      ],
      salary: '₹50,000 - ₹1,60,000/month',
      exam: 'GATE Score + Written Test + Interview'
    },
    {
      id: 'bhel',
      name: 'BHEL (Bharat Heavy Electricals Limited)',
      sector: 'Heavy Engineering',
      icon: <FaIndustry />,
      description: 'India\'s largest engineering and manufacturing enterprise in energy sector',
      eligibleBranches: ['Mechanical', 'Electrical', 'Electronics', 'Metallurgy', 'Civil', 'Computer Science'],
      positions: [
        { role: 'Engineer Trainee (Mechanical)', branches: ['Mechanical'], grade: 'E1' },
        { role: 'Engineer Trainee (Electrical)', branches: ['Electrical', 'EEE'], grade: 'E1' },
        { role: 'Engineer Trainee (Electronics)', branches: ['Electronics', 'ECE'], grade: 'E1' },
        { role: 'Supervisor Trainee', branches: ['Mechanical', 'Electrical', 'Electronics'], grade: 'S1' }
      ],
      salary: '₹60,000 - ₹2,00,000/month',
      exam: 'GATE Score + Interview'
    },
    {
      id: 'gail',
      name: 'GAIL (Gas Authority of India Limited)',
      sector: 'Natural Gas',
      icon: <FaIndustry />,
      description: 'India\'s flagship natural gas company',
      eligibleBranches: ['Mechanical', 'Chemical', 'Electrical', 'Instrumentation', 'Civil', 'Electronics', 'Petroleum'],
      positions: [
        { role: 'Executive Trainee (Mechanical)', branches: ['Mechanical'], grade: 'E1' },
        { role: 'Executive Trainee (Chemical)', branches: ['Chemical'], grade: 'E1' },
        { role: 'Executive Trainee (Electrical)', branches: ['Electrical'], grade: 'E1' },
        { role: 'Executive Trainee (Instrumentation)', branches: ['Instrumentation', 'ICE'], grade: 'E1' }
      ],
      salary: '₹60,000 - ₹1,80,000/month',
      exam: 'GATE Score + Written Test + Interview'
    },
    {
      id: 'coal-india',
      name: 'Coal India Limited',
      sector: 'Mining',
      icon: <FaMountain />,
      description: 'World\'s largest coal producer',
      eligibleBranches: ['Mining', 'Mechanical', 'Electrical', 'Electronics', 'Civil', 'Geology'],
      positions: [
        { role: 'Management Trainee (Mining)', branches: ['Mining'], grade: 'E3' },
        { role: 'Management Trainee (Mechanical)', branches: ['Mechanical'], grade: 'E3' },
        { role: 'Management Trainee (Electrical)', branches: ['Electrical'], grade: 'E3' },
        { role: 'Geologist', branches: ['Geology & Geophysics'], grade: 'E3' }
      ],
      salary: '₹50,000 - ₹1,60,000/month',
      exam: 'GATE Score + Interview'
    },
    {
      id: 'sail',
      name: 'SAIL (Steel Authority of India Limited)',
      sector: 'Steel',
      icon: <FaIndustry />,
      description: 'India\'s largest steel-making company',
      eligibleBranches: ['Metallurgy', 'Mechanical', 'Electrical', 'Electronics', 'Instrumentation', 'Chemical', 'Civil'],
      positions: [
        { role: 'Management Trainee (Technical)', branches: ['Metallurgy', 'Mechanical', 'Electrical'], grade: 'MT' },
        { role: 'Operator cum Technician', branches: ['Mechanical', 'Electrical', 'Electronics', 'Metallurgy'], grade: 'OCT' }
      ],
      salary: '₹50,000 - ₹1,80,000/month',
      exam: 'GATE Score + Interview'
    },
    {
      id: 'hal',
      name: 'HAL (Hindustan Aeronautics Limited)',
      sector: 'Aerospace & Defence',
      icon: <FaPlane />,
      description: 'India\'s premier aerospace and defence company',
      eligibleBranches: ['Aeronautical', 'Mechanical', 'Electrical', 'Electronics', 'Instrumentation', 'Computer Science', 'Metallurgy'],
      positions: [
        { role: 'Management Trainee (Technical)', branches: ['Aeronautical', 'Mechanical', 'Electrical', 'Electronics'], grade: 'E1' },
        { role: 'Design Engineer', branches: ['Aeronautical', 'Mechanical'], grade: 'E1' },
        { role: 'Technician', branches: ['Mechanical', 'Electrical', 'Electronics'], grade: 'T1' }
      ],
      salary: '₹60,000 - ₹2,00,000/month',
      exam: 'GATE Score + Written Test + Interview'
    },
    {
      id: 'bel',
      name: 'BEL (Bharat Electronics Limited)',
      sector: 'Electronics & Defence',
      icon: <FaMicrochip />,
      description: 'India\'s premier electronics company in defence sector',
      eligibleBranches: ['Electronics', 'Electrical', 'Computer Science', 'Instrumentation', 'Mechanical', 'Physics'],
      positions: [
        { role: 'Project Engineer (Electronics)', branches: ['Electronics', 'ECE'], grade: 'E1' },
        { role: 'Project Engineer (Electrical)', branches: ['Electrical', 'EEE'], grade: 'E1' },
        { role: 'Project Engineer (Computer Science)', branches: ['Computer Science', 'IT'], grade: 'E1' },
        { role: 'Senior Assistant Engineer', branches: ['Electronics', 'Electrical', 'Mechanical'], grade: 'E0' }
      ],
      salary: '₹50,000 - ₹1,80,000/month',
      exam: 'GATE Score + Interview'
    },
    {
      id: 'isro',
      name: 'ISRO (Indian Space Research Organisation)',
      sector: 'Space & Research',
      icon: <FaRocket />,
      description: 'India\'s national space agency',
      eligibleBranches: ['Mechanical', 'Electrical', 'Electronics', 'Computer Science', 'Aeronautical', 'Physics', 'Chemistry', 'Mathematics'],
      positions: [
        { role: 'Scientist/Engineer SC', branches: ['Mechanical', 'Electrical', 'Electronics', 'Computer Science', 'Aeronautical'], grade: 'SC' },
        { role: 'Technical Assistant', branches: ['Mechanical', 'Electrical', 'Electronics'], grade: 'TA' },
        { role: 'Technician B', branches: ['Mechanical', 'Electrical', 'Electronics', 'Computer Science'], grade: 'Tech-B' }
      ],
      salary: '₹56,100 - ₹1,77,500/month',
      exam: 'ICRB Exam + Interview'
    },
    {
      id: 'barc',
      name: 'BARC (Bhabha Atomic Research Centre)',
      sector: 'Nuclear Research',
      icon: <FaAtom />,
      description: 'India\'s premier nuclear research facility',
      eligibleBranches: ['Physics', 'Chemistry', 'Mathematics', 'Mechanical', 'Electrical', 'Electronics', 'Instrumentation', 'Chemical', 'Metallurgy', 'Computer Science'],
      positions: [
        { role: 'Scientific Officer', branches: ['Physics', 'Chemistry', 'Mathematics', 'All Engineering Branches'], grade: 'SO/C' },
        { role: 'Stipendiary Trainee', branches: ['Physics', 'Chemistry', 'Mathematics'], grade: 'Cat-I' },
        { role: 'Technical Officer', branches: ['All Engineering Branches'], grade: 'TO/C' }
      ],
      salary: '₹67,700 - ₹2,08,700/month',
      exam: 'OCES/DGFS + Interview'
    },
    {
      id: 'pgcil',
      name: 'PGCIL (Power Grid Corporation)',
      sector: 'Power Transmission',
      icon: <FaBolt />,
      description: 'Central Transmission Utility of India',
      eligibleBranches: ['Electrical', 'Electronics', 'Civil', 'Computer Science'],
      positions: [
        { role: 'Executive Trainee (Electrical)', branches: ['Electrical', 'EEE'], grade: 'E1' },
        { role: 'Executive Trainee (Civil)', branches: ['Civil'], grade: 'E1' },
        { role: 'Executive Trainee (Electronics)', branches: ['Electronics', 'ECE'], grade: 'E1' },
        { role: 'Diploma Trainee', branches: ['Electrical', 'Civil'], grade: 'D1' }
      ],
      salary: '₹60,000 - ₹1,80,000/month',
      exam: 'GATE Score + Interview'
    },
    {
      id: 'npcil',
      name: 'NPCIL (Nuclear Power Corporation)',
      sector: 'Nuclear Power',
      icon: <FaAtom />,
      description: 'Government owned corporation responsible for nuclear power generation',
      eligibleBranches: ['Mechanical', 'Electrical', 'Electronics', 'Instrumentation', 'Civil', 'Chemical'],
      positions: [
        { role: 'Executive Trainee', branches: ['Mechanical', 'Electrical', 'Electronics', 'Instrumentation', 'Civil'], grade: 'SA/B' },
        { role: 'Stipendiary Trainee', branches: ['Mechanical', 'Electrical', 'Electronics'], grade: 'ST/C' }
      ],
      salary: '₹67,700 - ₹2,08,700/month',
      exam: 'GATE Score + Interview'
    },
    {
      id: 'drdo',
      name: 'DRDO (Defence Research & Development)',
      sector: 'Defence Research',
      icon: <FaRocket />,
      description: 'India\'s premier defence research organization',
      eligibleBranches: ['Mechanical', 'Electrical', 'Electronics', 'Computer Science', 'Aeronautical', 'Metallurgy', 'Chemical', 'Physics', 'Chemistry', 'Mathematics', 'Biology'],
      positions: [
        { role: 'Scientist B', branches: ['All Engineering + Physics, Chemistry, Mathematics, Biology'], grade: 'Scientist-B' },
        { role: 'Senior Technical Assistant', branches: ['All Engineering Branches'], grade: 'STA-B' },
        { role: 'Junior Research Fellow', branches: ['Physics, Chemistry, Mathematics, Biology'], grade: 'JRF' }
      ],
      salary: '₹56,100 - ₹1,77,500/month',
      exam: 'DRDO RAC Exam + Interview'
    },
    {
      id: 'nhpc',
      name: 'NHPC (National Hydroelectric Power Corporation)',
      sector: 'Hydroelectric Power',
      icon: <FaBolt />,
      description: 'India\'s premier hydropower company',
      eligibleBranches: ['Civil', 'Mechanical', 'Electrical', 'Electronics', 'Geology'],
      positions: [
        { role: 'Trainee Engineer (Civil)', branches: ['Civil'], grade: 'E1' },
        { role: 'Trainee Engineer (Mechanical)', branches: ['Mechanical'], grade: 'E1' },
        { role: 'Trainee Engineer (Electrical)', branches: ['Electrical'], grade: 'E1' },
        { role: 'Field Engineer', branches: ['Civil', 'Mechanical', 'Electrical'], grade: 'FE' }
      ],
      salary: '₹60,000 - ₹1,80,000/month',
      exam: 'GATE Score + Interview'
    },
    {
      id: 'cochin-shipyard',
      name: 'Cochin Shipyard Limited',
      sector: 'Shipbuilding',
      icon: <FaShip />,
      description: 'India\'s largest shipbuilding facility',
      eligibleBranches: ['Mechanical', 'Marine Engineering', 'Electrical', 'Naval Architecture', 'Metallurgy', 'Civil'],
      positions: [
        { role: 'Executive Trainee (Marine)', branches: ['Marine Engineering', 'Mechanical'], grade: 'E1' },
        { role: 'Executive Trainee (Naval Architecture)', branches: ['Naval Architecture'], grade: 'E1' },
        { role: 'Executive Trainee (Electrical)', branches: ['Electrical'], grade: 'E1' },
        { role: 'Trainees', branches: ['Mechanical', 'Electrical', 'Marine'], grade: 'T1' }
      ],
      salary: '₹50,000 - ₹1,60,000/month',
      exam: 'GATE Score + Interview'
    },
    {
      id: 'ircon',
      name: 'IRCON International Limited',
      sector: 'Railway Construction',
      icon: <FaTrain />,
      description: 'Premier railway construction company',
      eligibleBranches: ['Civil', 'Mechanical', 'Electrical', 'Electronics'],
      positions: [
        { role: 'Junior Engineer (Civil)', branches: ['Civil'], grade: 'JE' },
        { role: 'Junior Engineer (Electrical)', branches: ['Electrical'], grade: 'JE' },
        { role: 'Junior Engineer (Mechanical)', branches: ['Mechanical'], grade: 'JE' }
      ],
      salary: '₹35,000 - ₹1,12,000/month',
      exam: 'Written Test + Interview'
    }
  ];

  const branchWiseOpportunities = [
    {
      id: 'mechanical',
      branch: 'Mechanical Engineering',
      icon: <FaWrench />,
      psuCount: '40+ PSUs',
      majorPSUs: ['ONGC', 'NTPC', 'IOCL', 'BHEL', 'GAIL', 'Coal India', 'SAIL', 'HAL', 'ISRO', 'BARC', 'NPCIL', 'NHPC', 'Indian Railways'],
      roles: [
        'Executive Trainee/Management Trainee',
        'Assistant Engineer',
        'Junior Engineer',
        'Design Engineer',
        'Production Engineer',
        'Maintenance Engineer',
        'Quality Control Engineer'
      ],
      subjects: ['Thermodynamics', 'Fluid Mechanics', 'Manufacturing', 'Machine Design', 'Industrial Engineering', 'Heat Transfer', 'Strength of Materials']
    },
    {
      id: 'electrical',
      branch: 'Electrical & Electronics Engineering (EEE)',
      icon: <FaBolt />,
      psuCount: '35+ PSUs',
      majorPSUs: ['NTPC', 'BHEL', 'PGCIL', 'ONGC', 'Power Grid', 'IOCL', 'GAIL', 'BEL', 'HAL', 'NPCIL', 'Coal India', 'Indian Railways'],
      roles: [
        'Executive Trainee (Electrical)',
        'Assistant Engineer (Electrical)',
        'Electrical Engineer',
        'Power Systems Engineer',
        'Control Systems Engineer',
        'Transmission Engineer',
        'Substation Engineer'
      ],
      subjects: ['Power Systems', 'Control Systems', 'Electrical Machines', 'Power Electronics', 'Measurements', 'Circuit Theory', 'Digital Electronics']
    },
    {
      id: 'electronics',
      branch: 'Electronics & Communication (ECE)',
      icon: <FaMicrochip />,
      psuCount: '30+ PSUs',
      majorPSUs: ['BEL', 'ISRO', 'DRDO', 'NTPC', 'BHEL', 'HAL', 'BARC', 'ONGC', 'IOCL', 'PGCIL', 'Doordarshan', 'BSNL'],
      roles: [
        'Project Engineer (Electronics)',
        'Scientist/Engineer',
        'Assistant Engineer',
        'Telecom Engineer',
        'Electronics Design Engineer',
        'Embedded Systems Engineer',
        'Signal Processing Engineer'
      ],
      subjects: ['Analog Circuits', 'Digital Electronics', 'Signals & Systems', 'Communication Systems', 'Control Systems', 'Electromagnetics', 'Microprocessors']
    },
    {
      id: 'civil',
      branch: 'Civil Engineering',
      icon: <FaBuilding />,
      psuCount: '35+ PSUs',
      majorPSUs: ['ONGC', 'NTPC', 'NHPC', 'Coal India', 'PGCIL', 'IOCL', 'NPCIL', 'IRCON', 'NBCC', 'Indian Railways', 'SJVN'],
      roles: [
        'Executive Trainee (Civil)',
        'Assistant Engineer (Civil)',
        'Site Engineer',
        'Structural Engineer',
        'Planning Engineer',
        'Construction Manager',
        'Project Engineer'
      ],
      subjects: ['Structural Engineering', 'Geotechnical Engineering', 'Environmental Engineering', 'Transportation Engineering', 'Water Resources', 'Construction Management', 'Surveying']
    },
    {
      id: 'chemical',
      branch: 'Chemical Engineering',
      icon: <FaFlask />,
      psuCount: '25+ PSUs',
      majorPSUs: ['IOCL', 'ONGC', 'GAIL', 'HPCL', 'BPCL', 'SAIL', 'BARC', 'DRDO', 'NTPC', 'Fertilizer Companies', 'Petrochemical Companies'],
      roles: [
        'Executive Trainee (Chemical)',
        'Process Engineer',
        'Production Engineer',
        'Research Officer',
        'Quality Control Analyst',
        'Safety Engineer',
        'Plant Engineer'
      ],
      subjects: ['Chemical Reaction Engineering', 'Process Control', 'Thermodynamics', 'Mass Transfer', 'Heat Transfer', 'Fluid Mechanics', 'Process Design']
    },
    {
      id: 'instrumentation',
      branch: 'Instrumentation & Control Engineering (ICE)',
      icon: <FaChartLine />,
      psuCount: '25+ PSUs',
      majorPSUs: ['ONGC', 'IOCL', 'GAIL', 'NTPC', 'BHEL', 'NPCIL', 'BARC', 'DRDO', 'HAL', 'BEL', 'Refineries'],
      roles: [
        'Instrumentation Engineer',
        'Control Systems Engineer',
        'Automation Engineer',
        'Process Control Engineer',
        'DCS Engineer',
        'SCADA Engineer'
      ],
      subjects: ['Control Systems', 'Process Control', 'Instrumentation', 'Sensors & Transducers', 'Industrial Automation', 'Digital Electronics', 'Measurements']
    },
    {
      id: 'computer',
      branch: 'Computer Science & IT',
      icon: <FaLaptop />,
      psuCount: '20+ PSUs',
      majorPSUs: ['ISRO', 'DRDO', 'BEL', 'HAL', 'BARC', 'BHEL', 'NTPC', 'ONGC', 'IOCL', 'Banks (SBI, PNB)', 'Insurance Companies'],
      roles: [
        'Software Engineer',
        'System Analyst',
        'Network Engineer',
        'Database Administrator',
        'Cyber Security Engineer',
        'IT Officer'
      ],
      subjects: ['Programming', 'Data Structures', 'Algorithms', 'DBMS', 'Operating Systems', 'Computer Networks', 'Software Engineering']
    },
    {
      id: 'metallurgy',
      branch: 'Metallurgical Engineering',
      icon: <FaIndustry />,
      psuCount: '15+ PSUs',
      majorPSUs: ['SAIL', 'RINL', 'NMDC', 'MOIL', 'Coal India', 'HAL', 'BARC', 'DRDO', 'Hindustan Copper', 'NAL'],
      roles: [
        'Metallurgical Engineer',
        'Materials Engineer',
        'Quality Control Engineer',
        'Research Scientist',
        'Production Engineer'
      ],
      subjects: ['Physical Metallurgy', 'Mechanical Metallurgy', 'Extractive Metallurgy', 'Materials Science', 'Heat Treatment', 'Corrosion']
    },
    {
      id: 'geology',
      branch: 'Geology & Geophysics',
      icon: <FaMountain />,
      psuCount: '12+ PSUs',
      majorPSUs: ['ONGC', 'Oil India', 'Coal India', 'NMDC', 'GSI', 'MECL', 'HCL', 'MOIL', 'GMDC'],
      roles: [
        'Geologist',
        'Geophysicist',
        'Exploration Geologist',
        'Mining Geologist',
        'Petroleum Geologist'
      ],
      subjects: ['Structural Geology', 'Mineralogy', 'Petrology', 'Geophysics', 'Sedimentology', 'Paleontology', 'Economic Geology']
    },
    {
      id: 'mining',
      branch: 'Mining Engineering',
      icon: <FaMountain />,
      psuCount: '10+ PSUs',
      majorPSUs: ['Coal India', 'NMDC', 'MOIL', 'GMDC', 'MECL', 'HCL', 'UCIL', 'SAIL'],
      roles: [
        'Mining Engineer',
        'Mine Manager',
        'Mine Planning Engineer',
        'Safety Engineer',
        'Blasting Engineer'
      ],
      subjects: ['Mine Planning', 'Underground Mining', 'Surface Mining', 'Mine Safety', 'Rock Mechanics', 'Mineral Processing']
    },
    {
      id: 'petroleum',
      branch: 'Petroleum Engineering',
      icon: <FaOilCan />,
      psuCount: '8+ PSUs',
      majorPSUs: ['ONGC', 'Oil India', 'IOCL', 'BPCL', 'HPCL', 'GAIL', 'OIL', 'Engineers India'],
      roles: [
        'Petroleum Engineer',
        'Reservoir Engineer',
        'Drilling Engineer',
        'Production Engineer',
        'Pipeline Engineer'
      ],
      subjects: ['Reservoir Engineering', 'Drilling Engineering', 'Production Technology', 'Petroleum Geology', 'Well Testing']
    },
    {
      id: 'physics',
      branch: 'Physics',
      icon: <FaAtom />,
      psuCount: '10+ PSUs',
      majorPSUs: ['ISRO', 'BARC', 'DRDO', 'DAE', 'IGCAR', 'IPR', 'TIFR', 'BEL'],
      roles: [
        'Scientific Officer',
        'Scientist',
        'Research Fellow',
        'Technical Officer',
        'Junior Research Fellow'
      ],
      subjects: ['Quantum Mechanics', 'Nuclear Physics', 'Solid State Physics', 'Electronics', 'Electromagnetic Theory', 'Thermodynamics']
    },
    {
      id: 'chemistry',
      branch: 'Chemistry',
      icon: <FaFlask />,
      psuCount: '12+ PSUs',
      majorPSUs: ['BARC', 'DRDO', 'IOCL', 'ONGC', 'Fertilizer PSUs', 'Pharma PSUs', 'CSIR Labs', 'DAE'],
      roles: [
        'Scientific Officer',
        'Chemist',
        'Quality Control Analyst',
        'Research Officer',
        'Chemical Analyst'
      ],
      subjects: ['Organic Chemistry', 'Inorganic Chemistry', 'Physical Chemistry', 'Analytical Chemistry', 'Biochemistry']
    },
    {
      id: 'mathematics',
      branch: 'Mathematics',
      icon: <FaChartLine />,
      psuCount: '8+ PSUs',
      majorPSUs: ['ISRO', 'BARC', 'DRDO', 'CSIR', 'Statistics PSUs', 'UIDAI', 'Research Labs'],
      roles: [
        'Scientist',
        'Scientific Officer',
        'Statistician',
        'Data Analyst',
        'Research Fellow'
      ],
      subjects: ['Calculus', 'Algebra', 'Differential Equations', 'Numerical Methods', 'Probability & Statistics', 'Operations Research']
    },
    {
      id: 'biology',
      branch: 'Biology/Biotechnology',
      icon: <FaFlask />,
      psuCount: '6+ PSUs',
      majorPSUs: ['DRDO', 'BARC', 'CSIR Labs', 'DBT Labs', 'ICAR', 'Biotech PSUs'],
      roles: [
        'Scientific Officer',
        'Research Fellow',
        'Biotechnologist',
        'Microbiologist',
        'Lab Technician'
      ],
      subjects: ['Molecular Biology', 'Genetics', 'Biochemistry', 'Microbiology', 'Cell Biology', 'Biotechnology']
    },
    {
      id: 'aeronautical',
      branch: 'Aeronautical/Aerospace Engineering',
      icon: <FaPlane />,
      psuCount: '8+ PSUs',
      majorPSUs: ['HAL', 'ISRO', 'DRDO', 'NAL', 'ADA', 'BEL', 'Air India Engineering'],
      roles: [
        'Design Engineer',
        'Scientist/Engineer',
        'Aerodynamics Engineer',
        'Structural Engineer',
        'Propulsion Engineer'
      ],
      subjects: ['Aerodynamics', 'Flight Mechanics', 'Aircraft Structures', 'Propulsion', 'Control Systems', 'Avionics']
    }
  ];

  const features = [
    {
      icon: <FaBook />,
      title: 'GATE Focused Training',
      description: 'Comprehensive preparation aligned with GATE syllabus for PSU recruitment'
    },
    {
      icon: <FaLaptop />,
      title: 'Technical Interview Prep',
      description: 'Mock interviews and technical discussions to crack PSU interviews'
    },
    {
      icon: <FaUsers />,
      title: 'Industry Expert Faculty',
      description: 'Learn from professionals with PSU experience and GATE qualifications'
    },
    {
      icon: <FaClock />,
      title: 'Branch-Specific Coaching',
      description: 'Specialized courses tailored for each engineering discipline'
    },
    {
      icon: <FaFileAlt />,
      title: 'Previous Year Analysis',
      description: 'Detailed analysis of PSU recruitment patterns and questions'
    },
    {
      icon: <FaTrophy />,
      title: 'Placement Assistance',
      description: 'Guidance on PSU application process and documentation'
    }
  ];

  const recruitmentProcess = [
    {
      stage: 'GATE Score',
      description: 'Most PSUs recruit through GATE scores. Valid GATE score is mandatory.',
      weightage: '70-85%'
    },
    {
      stage: 'Written Test/GD',
      description: 'Some PSUs conduct additional written test or group discussion.',
      weightage: '10-15%'
    },
    {
      stage: 'Personal Interview',
      description: 'Final selection through technical and HR interview rounds.',
      weightage: '10-20%'
    }
  ];

  const benefits = [
    'Excellent salary packages (₹40,000 - ₹2,00,000+ per month)',
    'Job security and stability',
    'Government employee benefits',
    'Medical facilities for self and family',
    'Housing facilities or HRA',
    'Leave Travel Allowance (LTA)',
    'Pension and retirement benefits',
    'Career growth opportunities',
    'Work-life balance',
    'Prestigious work environment',
    'Contribution to nation building',
    'Performance-based incentives'
  ];

  const togglePSU = (id) => {
    setExpandedPSU(expandedPSU === id ? null : id);
  };

  const toggleBranch = (id) => {
    setExpandedBranch(expandedBranch === id ? null : id);
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Hero Section */}
      <div className="text-white py-5 my-5" style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="display-4 fw-bold mb-3">PSU Recruitment Training</h1>
              <p className="lead mb-4">
                Comprehensive training for Public Sector Undertaking recruitments across all engineering and science disciplines. Join India's most prestigious government organizations through GATE and direct recruitment.
              </p>
              <button className="btn btn-light btn-lg px-4 me-3">Start Your Journey</button>
              <button className="btn btn-outline-light btn-lg px-4">Explore PSUs</button>
            </div>
            <div className="col-lg-4 text-center">
              <FaIndustry size={150} className="opacity-75" />
            </div>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="container py-4">
        <div className="row g-4">
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-primary fw-bold mb-1">350+</h3>
              <p className="text-muted mb-0">PSUs in India</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-success fw-bold mb-1">20,000+</h3>
              <p className="text-muted mb-0">Annual Vacancies</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-info fw-bold mb-1">All Branches</h3>
              <p className="text-muted mb-0">Engineering & Science</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-warning fw-bold mb-1">₹40K-2L</h3>
              <p className="text-muted mb-0">Salary Range/Month</p>
            </div>
          </div>
        </div>
      </div>

      {/* Major PSUs Section */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Major PSUs Hiring</h2>
        <div className="row">
          <div className="col-12">
            {majorPSUs.map((psu) => (
              <div key={psu.id} className="card mb-3 border-0 shadow-sm">
                <div 
                  className="card-header bg-light d-flex justify-content-between align-items-center"
                  onClick={() => togglePSU(psu.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center">
                    <div className="text-primary me-3" style={{ fontSize: '1.8rem' }}>
                      {psu.icon}
                    </div>
                    <div>
                      <h5 className="mb-1 fw-bold text-primary">{psu.name}</h5>
                      <small className="text-muted">{psu.sector} • {psu.description}</small>
                    </div>
                  </div>
                  {expandedPSU === psu.id ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {expandedPSU === psu.id && (
                  <div className="card-body">
                    <div className="row mb-4">
                      <div className="col-md-4">
                        <p className="mb-1"><strong>Salary Range:</strong></p>
                        <p className="text-success fw-bold">{psu.salary}</p>
                      </div>
                      <div className="col-md-4">
                        <p className="mb-1"><strong>Selection Process:</strong></p>
                        <p className="text-muted">{psu.exam}</p>
                      </div>
                      <div className="col-md-4">
                        <p className="mb-1"><strong>Sector:</strong></p>
                        <p className="text-muted">{psu.sector}</p>
                      </div>
                    </div>
                    
                    <h6 className="fw-bold mb-3">Eligible Branches:</h6>
                    <div className="d-flex flex-wrap gap-2 mb-4">
                      {psu.eligibleBranches.map((branch, idx) => (
                        <span key={idx} className="badge bg-info text-dark">{branch}</span>
                      ))}
                    </div>

                    <h6 className="fw-bold mb-3">Available Positions:</h6>
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="table-light">
                          <tr>
                            <th>Position</th>
                            <th>Eligible Branches</th>
                            <th>Grade</th>
                          </tr>
                        </thead>
                        <tbody>
                          {psu.positions.map((position, idx) => (
                            <tr key={idx}>
                              <td className="fw-semibold">{position.role}</td>
                              <td>
                                {position.branches.map((branch, bIdx) => (
                                  <span key={bIdx} className="badge bg-secondary me-1">{branch}</span>
                                ))}
                              </td>
                              <td><span className="badge bg-success">{position.grade}</span></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Branch-wise Opportunities */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-4 fw-bold">Branch-wise PSU Opportunities</h2>
          <p className="text-center text-muted mb-5">
            Explore PSU opportunities based on your educational background
          </p>
          <div className="row">
            <div className="col-12">
              {branchWiseOpportunities.map((branch) => (
                <div key={branch.id} className="card mb-3 border-0 shadow-sm">
                  <div 
                    className="card-header d-flex justify-content-between align-items-center"
                    onClick={() => toggleBranch(branch.id)}
                    style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                  >
                    <div className="d-flex align-items-center">
                      <div className="text-primary me-3" style={{ fontSize: '1.5rem' }}>
                        {branch.icon}
                      </div>
                      <div>
                        <h5 className="mb-1 fw-bold">{branch.branch}</h5>
                        <small className="text-muted">{branch.psuCount} recruiting</small>
                      </div>
                    </div>
                    {expandedBranch === branch.id ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                  {expandedBranch === branch.id && (
                    <div className="card-body">
                      <div className="row mb-4">
                        <div className="col-12">
                          <h6 className="fw-bold mb-3">Major PSUs Hiring:</h6>
                          <div className="d-flex flex-wrap gap-2 mb-4">
                            {branch.majorPSUs.map((psu, idx) => (
                              <span key={idx} className="badge bg-primary">{psu}</span>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="row mb-4">
                        <div className="col-md-6">
                          <h6 className="fw-bold mb-3">Typical Job Roles:</h6>
                          <ul className="list-unstyled">
                            {branch.roles.map((role, idx) => (
                              <li key={idx} className="mb-2">
                                <FaCheckCircle className="text-success me-2" />
                                {role}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-md-6">
                          <h6 className="fw-bold mb-3">Key Subjects for GATE:</h6>
                          <div className="row">
                            {branch.subjects.map((subject, idx) => (
                              <div key={idx} className="col-12 mb-2">
                                <FaBook className="text-info me-2" size={12} />
                                <small>{subject}</small>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Recruitment Process */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">PSU Recruitment Process</h2>
        <div className="row g-4">
          {recruitmentProcess.map((stage, idx) => (
            <div key={idx} className="col-md-4">
              <div className="card border-0 shadow h-100">
                <div className="card-body text-center p-4">
                  <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px' }}>
                    <h3 className="mb-0">{idx + 1}</h3>
                  </div>
                  <h5 className="fw-bold mb-3">{stage.stage}</h5>
                  <p className="text-muted mb-3">{stage.description}</p>
                  <span className="badge bg-success">{stage.weightage} Weightage</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Benefits Section */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Why Join PSUs?</h2>
          <div className="row g-3">
            {benefits.map((benefit, idx) => (
              <div key={idx} className="col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body d-flex align-items-center p-3">
                    <FaCheckCircle className="text-success me-3 flex-shrink-0" size={24} />
                    <p className="mb-0">{benefit}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Training Features */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Our PSU Training Features</h2>
        <div className="row g-4">
          {features.map((feature, idx) => (
            <div key={idx} className="col-md-4">
              <div className="card border-0 shadow-sm h-100 text-center p-4">
                <div className="text-primary mb-3" style={{ fontSize: '3rem' }}>
                  {feature.icon}
                </div>
                <h5 className="fw-bold mb-3">{feature.title}</h5>
                <p className="text-muted">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Comparison Section */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Sector-wise PSU Categories</h2>
          <div className="row g-4">
            <div className="col-md-3">
              <div className="card border-0 shadow text-center p-4">
                <FaOilCan size={50} className="text-primary mb-3" />
                <h5 className="fw-bold">Oil & Gas</h5>
                <p className="text-muted small">ONGC, IOCL, GAIL, BPCL, HPCL, Oil India</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow text-center p-4">
                <FaBolt size={50} className="text-warning mb-3" />
                <h5 className="fw-bold">Power Sector</h5>
                <p className="text-muted small">NTPC, PGCIL, NHPC, NPCIL, Power Grid</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow text-center p-4">
                <FaRocket size={50} className="text-info mb-3" />
                <h5 className="fw-bold">Defence & Space</h5>
                <p className="text-muted small">ISRO, DRDO, HAL, BEL, BARC</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow text-center p-4">
                <FaIndustry size={50} className="text-success mb-3" />
                <h5 className="fw-bold">Heavy Industries</h5>
                <p className="text-muted small">BHEL, SAIL, Coal India, NMDC</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Eligibility Section */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">General Eligibility Criteria</h2>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card border-primary h-100">
              <div className="card-header bg-primary text-white text-center">
                <h5 className="mb-0">Educational Qualification</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-2">✓ B.E./B.Tech for Engineering posts</li>
                  <li className="mb-2">✓ M.Sc. for Science posts</li>
                  <li className="mb-2">✓ Diploma for Technical Assistant posts</li>
                  <li className="mb-2">✓ Minimum 60% marks (55% for reserved)</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-success h-100">
              <div className="card-header bg-success text-white text-center">
                <h5 className="mb-0">Age Limit</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-2">✓ Executive Trainee: 18-30 years</li>
                  <li className="mb-2">✓ Management Trainee: 18-28 years</li>
                  <li className="mb-2">✓ Technician: 18-30 years</li>
                  <li className="mb-2">✓ Relaxation for reserved categories</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-info h-100">
              <div className="card-header bg-info text-white text-center">
                <h5 className="mb-0">GATE Requirement</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-2">✓ Valid GATE score required</li>
                  <li className="mb-2">✓ Score valid for 3 years</li>
                  <li className="mb-2">✓ Minimum qualifying marks vary</li>
                  <li className="mb-2">✓ Some PSUs: Direct recruitment</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container py-5">
        <div className="card border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' }}>
          <div className="card-body text-white text-center p-5">
            <h2 className="fw-bold mb-3">Ready to Join a Prestigious PSU?</h2>
            <p className="lead mb-4">
              Start your preparation today with our comprehensive training programs tailored for your branch
            </p>
            <button className="btn btn-light btn-lg px-5 me-3">Enroll Now</button>
            <button className="btn btn-outline-light btn-lg px-5">Download Brochure</button>
          </div>
        </div>
      </div>

      {/* Footer Note */}
      <div className="bg-dark text-white py-4">
        <div className="container text-center">
          <p className="mb-2">
            <strong>Note:</strong> PSU recruitments are conducted throughout the year. Stay updated with notifications and prepare systematically.
          </p>
          <p className="mb-0 small text-muted">
            Visit individual PSU websites for specific recruitment notifications and eligibility criteria
          </p>
        </div>
      </div>
    </div>
  );
};

export default PSUPage;